import { render } from "./ArticleNode.vue?vue&type=template&id=f8cdb33c"
import script from "./ArticleNode.vue?vue&type=script&lang=js"
export * from "./ArticleNode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__